import { Typography } from "@mui/material";
import BreadCrumbs from "../../Breadcrumbs";
import StyledTitleDot from "../../common/StyledTitleDot";
import { AirportServicesProvider } from "../../../contexts/AirportServices/AirportServices";
import Steps from "./Steps/Steps";
import { useTranslation } from "react-i18next";

export default function AirportServices() {
  const { t } = useTranslation();

  return (
    <AirportServicesProvider>
      <Typography className="title" variant="h4">
        {t("services")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("services"), t("airportTransfer.title"), t("details")]} />

      <Steps />
    </AirportServicesProvider>
  );
}
